angular.module('app.controllers').controller 'VideosListCtrl', [
  '$scope', '$rootScope', 'UI', 'APIRead', 'APIReadTable', 'Table', 'APIData'
].append (self, root, UI, APIRead, APIReadTable, Table, APIData) ->


  APIData.query {slug: "videos-#{root.lang}"}, (data) ->
    self.videos_deep = data
  , (response) ->
    UI.notify false, response.data.error
    
  tableName   = 's.videos.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName

  APIRead.query {limit: 3, entry_type: 'videos', reverse: false, lang: root.lang}, (data) ->
    self.topvideos = data  
  , (response) ->
    UI.notify false, response.data.error

  self.videos = Table
    name: tableName
    type: "partial"
    resource: APIReadTable
    params:
      limit: 12
      entry_type: 'videos'
      offset_increase: 3
      lang: root.lang
  
  self.$watch 'videos.params', (newObj, oldObj) ->
    self.page = 1
  , true

  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.videos.data.pages
    
    self.page++ 
    
    params = angular.copy(self.videos.params)
    params.page = self.page

    self.moreLoad = true
    APIRead.query params, (data) ->
      self.more = data
      self.videos.data.display = self.videos.data.display.concat(self.more)
      self.moreLoad = false
    , (response) ->
      UI.notify false, response.data.error
